import React, { ReactNode, useState } from 'react';
import { ErrorsHandler } from './errors-handler/ErrorsHandler.web';
import { ErrorType } from './errors-handler/ErrorsHandler.types';
import { ErrorViews } from './error-views/ErrorViews';

export const GlobalErrorBoundary = ({ children }: { children: ReactNode }) => {
  const [error, setError] = useState<ErrorType | undefined>(undefined);

  return (
    <>
      <ErrorsHandler setError={setError} />
      <ErrorViews error={error} setError={setError} />
      {children}
    </>
  );
};
